import type { AddToBasketFragmentFragment } from '@packages/gql/generated/shopping/graphql';

export const mockedProduct: AddToBasketFragmentFragment = {
  availability: {
    state: 'AVAILABLE',
    isOrderable: true,
  },
  akl: 'AKL',
  price: {
    saving: null,
    valueOld: 72900,
    currency: 'EUR',
    value: 51472,
  },
  sku: 'SKU',
  marketcode: null,
};
